if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
        this.initReadMoreBtn();
        this.productInitData();
        this.filterVariantOptions();
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      productInitData() {
        const productUrl = this.pendingRequestUrl || this.dataset.url;
        const variant = this.getSelectedVariant(document.querySelector('product-info'));
        if (!variant) return;

        const productHandle = productUrl.match(/products\/([^/?#]+)/);

        if (!productHandle) return;
        this.getProductData(productHandle[1]).then(productData => {
          this.updateRequiredPartsModalTrigger(variant.id);
          this.updatePartsAccordion(variant.id);
          this.updateAccordionSwiperSlider();
          this.showWishlistIcon(variant.id);
          const productMediaContainer = this.querySelector(`product-media`)
          if (!productMediaContainer) return;
          productMediaContainer.swapImages(productData, variant);
          productMediaContainer.initPhotoSwipeEvents();
        });
      }

      showWishlistIcon(variantId) {
        this.querySelectorAll('wishlist-icon').forEach(wishlistIcon => {
          wishlistIcon.classList.remove('active_variant');
        });
        setTimeout(() => {
          const matchingIcon = this.querySelector(`wishlist-icon[data-variant-id="${variantId}"]`);
          if (matchingIcon) matchingIcon.classList.add('active_variant');
        }, 500);
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.breadCrumbUrl = this.buildBreadCrumbUrlWithParams(productUrl, selectedOptionValues);
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);


          const productHandle = productUrl.match(/products\/([^/?#]+)/);
          if (productHandle) {
            this.getProductData(productHandle[1]).then(productData => {
              const relatedProducts = this.relatedProducts;
              if (relatedProducts) {
                const relatedUrl = relatedProducts.dataset.url;
                const newProductUrl = relatedUrl.replace(/product_id=([^&]*)/, `product_id=${productData.id}`);
                relatedProducts.dataset.url = newProductUrl;
                relatedProducts.updateUrlAndReload(newProductUrl);
              }
            });
          }

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('product-info'),
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {

        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          }).finally(() => {

            const popupModalElement = document.querySelectorAll('popup-modal');
            popupModalElement.forEach(popupModal => {
                popupModal.initTriggers();
            });
            const homeViewerElement = document.querySelector('home-viewer');
            if (homeViewerElement) homeViewerElement.listenToViewerOpen();
            const viewer3dElement = document.querySelector('viewer-3d');
            if (viewer3dElement) viewer3dElement.listenToViewerOpen();

            if (typeof PriceSpider !== 'undefined')  PriceSpider.rebind();

            this.productInitData();
            this.filterVariantOptions();
            this. wishlistIconInit();
            if (!this.breadCrumbUrl) return;
            this.updateBreadCrumb(this.breadCrumbUrl);
          });
      }

      triggerSelectedVariant() {
        const variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) return;

        const allFieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
        const firstFieldsetWithoutSelection = allFieldsets.find(fieldset => {
          return !fieldset.querySelector('input[type="radio"]:checked');
        });
        if (!firstFieldsetWithoutSelection) return;

        const radio = firstFieldsetWithoutSelection.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }

      filterVariantOptions () {
        const productVariantData = window.variantsGlobalSuperProduct;
        if (!productVariantData) return;

        const variantSelects = document.querySelector('variant-selects');
        if (!variantSelects) return;

        const firstFieldset = variantSelects.querySelector('fieldset');
        const checkedInput = firstFieldset?.querySelector('input[type="radio"]:checked');
        const checkedValue = checkedInput?.value;
        if (!checkedValue) return;

        const filteredVariants = productVariantData.filter(variant => {
          return variant.title.startsWith(checkedValue);
        });

          const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset')).slice(1);
          fieldsets.forEach((fieldset, index) => {
            const optionPosition = index + 2;
            const radioInputs = fieldset.querySelectorAll('input[type="radio"]');
            radioInputs.forEach(input => {
              const value = input.value;
              const exists = filteredVariants.some(variant => {
                return variant[`option${optionPosition}`] === value;
              });

              if (!exists) {
                const swatchContainer = input.closest('.swatch');
                if (swatchContainer) {
                  swatchContainer.remove();
                }
              }
            });
            const remainingInputs = fieldset.querySelectorAll('input[type="radio"]');
            if (remainingInputs.length === 0) {
              fieldset.remove();
            }
          });
          this.triggerSelectedVariant();
      };

      wishlistIconInit () {
        const wishlistIcon = this.querySelector('wishlist-icon');
        if (!wishlistIcon) return;
        let selector = "product-info";
        if(window._swat){
            window._swat.initializeActionButtons(selector);
        }else{
            window.SwymCallbacks = window.SwymCallbacks || [];
            window.SwymCallbacks.push(function(){
                window._swat.initializeActionButtons(selector);
            });
        }
      }

      updateBreadCrumb(url) {
        fetch(url, { signal: this.abortController.signal })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          document.querySelector('.breadcrumbs-section').innerHTML = html.querySelector('.breadcrumbs-section').innerHTML;

          HTMLUpdateUtility.viewTransition(
            document.querySelector('.breadcrumbs-section'),
            html.querySelector('.breadcrumbs-section'),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Abort Fetch');
          } else {
            console.error('Error update breadcrumb:', error);
          }
        });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        // param to set a product custom view
        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      buildBreadCrumbUrlWithParams(url, optionValues) {
        const params = [];
        const breadCrumbSection = document.querySelector('.breadcrumbs-section');

        if (!breadCrumbSection) return;

        params.push(`section_id=${breadCrumbSection.id}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }
        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
          this.updateMedia(html, variant ,productUrl);
          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          this.updateRequiredPartsModalTrigger(variant.id);
          this.updatePartsAccordion(variant.id);

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateRequiredPartsModalTrigger(variantId) {
        const requiredPartsMessages = this.querySelectorAll('[data-required-parts-modal-message]');
        requiredPartsMessages?.forEach(message => {
            message.dataset.requiredPartsModalMessage === String(variantId) ? 
                message.classList.remove('hidden') : 
                message.classList.add('hidden');
        });
      }

      updatePartsAccordion(variantId) {
        const accordions = this.querySelectorAll('[data-product-parts]');
        accordions?.forEach(message => {
          message.dataset.productParts === String(variantId) ? 
              message.classList.remove('hidden') : 
              message.classList.add('hidden');
        });
      }

      updateAccordionSwiperSlider() {
        this.querySelectorAll('component-accordion').forEach(accordion => {
          const accordionSwiper = accordion.querySelectorAll('swiper-slider');
          if (accordionSwiper.length < 1) return;
          accordionSwiper.forEach(slider => {
            if(!slider) return
            slider.reinitSlider();
          });

        });
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      async getProductData(productHandle) {
          try {
              const product = await window.theme.product.loadProduct(productHandle);
              return product;
          } catch (error) {
              console.error('Error to get product info:', error);
          }
      }

      updateMedia(html, variant, productUrl) {

        const productHandle = productUrl.match(/products\/([^/?#]+)/);

        let variantFeaturedMediaId = variant?.featured_media?.id
        if (!variantFeaturedMediaId) return;

        // const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGallerySource = this.querySelector('product-media .product-media .swiper .swiper-wrapper');

        // const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
        const mediaGalleryDestination = html.querySelector(`product-media .product-media .swiper .swiper-wrapper`);

        const refreshSourceData = () => {
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('.swiper-slide[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('.swiper-slide[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`.swiper-slide:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated?.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'product-recommendations'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      initReadMoreBtn() {
        this.querySelector('[data-read-more-button]')?.addEventListener('click', this.scrollToDescritpion.bind(this));
      }

      scrollToDescritpion() {
          const overviewAccordion = document.querySelector('[data-overview-accordion]');
          if (!overviewAccordion) return;

          const accordionTrigger = overviewAccordion.querySelector('[data-accordion-trigger]');
          if (!accordionTrigger) return;

          const offset = 100;
          const elementTop = accordionTrigger.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
              top: elementTop - offset,
              behavior: 'smooth'
          });

          if (!overviewAccordion.isOpen) {
              accordionTrigger.click();
          }
      }
    }
  );
}
